import { BeMenuBar, type BeMenuBarBorder, BeMenuBarItem, BeStack } from "@beos-css/react/index.ts";

import iconDisk from "../../icons/disk.png";

const BORDERS: [BeMenuBarBorder, string][] = [
	["frame", "B_BORDER_FRAME (default)"],
	["contents", "B_BORDER_CONTENTS"],
	["each-item", "B_BORDER_EACH_ITEM"],
	["off", "B_BORDER_OFF"],
];

export function MenuBarDemo() {
	return (
		<section id="demo-menu-bar">
			<h2>Menu bar (BMenuBar)</h2>
			<p>
				A BMenu laid out <code>B_ITEMS_IN_ROW</code>, but its pad is its own: <code>GetItemMargins</code> reports 8/2/8/2 against a column
				menu's <code>standard_pad(14, 1, 20, 1)</code>, which is where the wide "File Edit View" spacing comes from. The bar is 20 rows, and
				a bar item never draws a submenu caret — <code>DrawSubmenuSymbol</code> bails on a BMenuBar.
			</p>
			<BeStack gap="row" align="start">
				<BeMenuBar aria-label="Tracker">
					{/* ModelMenuItem with fExtraPad: 6 past the bar's 8 is the column menu's 14 */}
					<BeMenuBarItem icon={<img src={iconDisk} alt="" />} onSelect={() => {}}>
						beos
					</BeMenuBarItem>
					<BeMenuBarItem onSelect={() => {}}>File</BeMenuBarItem>
					<BeMenuBarItem onSelect={() => {}}>Window</BeMenuBarItem>
					<BeMenuBarItem onSelect={() => {}}>Attributes</BeMenuBarItem>
				</BeMenuBar>

				{/* selected is how a bar item looks while its menu is down */}
				<BeMenuBar aria-label="States">
					<BeMenuBarItem selected onSelect={() => {}}>
						Selected
					</BeMenuBarItem>
					<BeMenuBarItem onSelect={() => {}}>Default</BeMenuBarItem>
					<BeMenuBarItem disabled>Disabled</BeMenuBarItem>
				</BeMenuBar>
			</BeStack>

			<h3>Border modes (SetBorder)</h3>
			<p>
				All four of <code>BMenuBar::SetBorder</code>'s modes. <code>CONTENTS</code> strikes the same frame heavier, <code>EACH_ITEM</code>
				moves it off the bar and onto every item, and <code>OFF</code> draws nothing. The single ground-coloured pixels at the corners are
				R5's own: it strokes each line the full width, then pokes them back.
			</p>
			<BeStack gap="row" align="start">
				{BORDERS.map(([border, label]) => (
					<div key={border}>
						<BeMenuBar aria-label={label} border={border}>
							<BeMenuBarItem onSelect={() => {}}>File</BeMenuBarItem>
							<BeMenuBarItem onSelect={() => {}}>Edit</BeMenuBarItem>
							<BeMenuBarItem disabled>Disabled</BeMenuBarItem>
						</BeMenuBar>
						<code>{label}</code>
					</div>
				))}
			</BeStack>
		</section>
	);
}
